import { Button, Col, Form, Row, Select } from "antd";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useState } from "react";
import { toYMD, validateInput } from "../../../../tools/tools";
import Iinput from "../../../auxiliary/inputs/Input";

const Search = ({ t, style, setCreditCard, creditCard }) => {
	const { queryBankCardProfileByCertNo, queryBankCardProfileByPassportNo, queryBankCardProfileByEmail } = useDealer();
	const { queryCityByCityId } = useAPIPublic();

	const [frmService] = Form.useForm();

	const [list, setList] = useState({
		TypeOfSearch: [
			{ value: "0", name: "کدملی" },
			{ value: "1", name: "پست الکترونیکی" },
			{ value: "2", name: "پاسپورت" },
		],
		selectedType: "",
		isProgress: false,
	});

	const handleSearch = async (values) => {
		try {
			setList((l) => ({ ...l, isProgress: true }));
			let response = null;
			if (values?.email) {
				response = await queryBankCardProfileByEmail(values.email);
				setCreditCard((prev) => ({ ...prev, type: "email" }));
			} else if (values.passport) {
				response = await queryBankCardProfileByPassportNo(values.passport);
				setCreditCard((prev) => ({ ...prev, type: "passportNumber" }));
			} else if (values.certno) {
				response = await queryBankCardProfileByCertNo(values.certno);
				setCreditCard((prev) => ({ ...prev, type: "nationalId" }));
			}

			if (!response?.HasError) {
				if (response?.Result) {
					const profile = {
						firstName: response?.Result?.firstName,
						lastName: response?.Result?.lastName,
						mothername: response?.Result?.mothername,
						fathername: response?.Result?.fathername,
						passportNumber: response?.Result?.passportNumber,
						nationalId: response?.Result?.nationalId,
						mobile: response?.Result?.mobile,
						email: response?.Result?.email,
						occupationid: response?.Result?.jobId,
						birthdate: toYMD(response?.Result?.birthDate),
					};
					let provinceid = await queryCityByCityId(response?.Result?.address?.cityId);

					const address = {
						cityid: provinceid?.inT_PayredCityCode != null ? response?.Result?.address?.cityId : null,
						provinceid: provinceid?.intfK_ProvinceId,
						address: response?.Result?.address?.address,
						postalcode: response?.Result?.address?.postalCode,
					};

					setList((l) => ({ ...l, isProgress: false }));
					setCreditCard((prev) => ({ ...prev, profile, address, step: null }));
				} else {
					setList((l) => ({ ...l, isProgress: false }));
					setCreditCard((prev) => ({ ...prev, profile: null, type: null, address: null, step: 0 }));
				}
			} else {
				setList((l) => ({ ...l, isProgress: false }));
				setCreditCard((prev) => ({ ...prev, profile: null, type: null, address: null, step: 0 }));
			}
		} catch (error) {
			console.error(error);
			setList((l) => ({ ...l, isProgress: false }));
			setCreditCard((prev) => ({ ...prev, profile: null, type: null, address: null, step: 0 }));
		}
	};
	return (
		<div className="holder-form-filter">
			<br />
			<Form id="frmService" name="frmService" layout="vertical" form={frmService} onFinish={handleSearch}>
				<Row gutter={30} justify={"start"}>
					<Col xxl={6} xl={8} lg={10} md={10} sm={12} xs={24}>
						<Form.Item className="input-normal" name="type" label="جستجو بر اساس">
							<Select placeholder="جستجو بر اساس" onChange={(item) => setList({ ...list, selectedType: item })}>
								{list.TypeOfSearch.map((type, key) => (
									<Select.Option key={key} value={type.value}>
										{type.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={30} justify={"start"}>
					<Col xxl={6} xl={8} lg={10} md={10} sm={12} xs={24}>
						{list.selectedType == "0" && (
							<Form.Item
								className="input-normal"
								name="certno"
								rules={[
									validateInput({
										t: t,
										validate: true,
										type: "number",
										length: 10,
									}),
								]}>
								<Iinput placeholder="جستجو کدملی" dir="ltr" />
							</Form.Item>
						)}

						{list.selectedType == "1" && (
							<Form.Item
								className="input-normal"
								name="email"
								rules={[
									validateInput({
										t: t,
										validate: true,
										type: "email",
									}),
								]}>
								<Iinput placeholder="جستجو پست الکترونیکی" dir="ltr" />
							</Form.Item>
						)}

						{list.selectedType == "2" && (
							<Form.Item
								className="input-normal"
								name="passport"
								rules={[
									validateInput({
										t: t,
										validate: true,
										type: "passport",
										length: 15,
									}),
								]}>
								<Iinput placeholder="جستجو پاسپورت" dir="ltr" />
							</Form.Item>
						)}
					</Col>
					{list.selectedType !== "" && (
						<Col span={1} style={{ margin: "0" }}>
							<Button htmlType="submit" loading={list.isProgress} key={frmService} className={`btn-normal btn-green ${style.button}`}>
								جستجو
							</Button>
						</Col>
					)}
				</Row>
			</Form>
		</div>
	);
};

export default Search;
